import axios from "axios";

const client = axios.create({ baseURL: "/api" });

client.interceptors.request.use(cfg => {
  const token = sessionStorage.getItem("iws_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Unwrap data + handle auth errors in ONE place (not twice)
client.interceptors.response.use(
  r => r.data,
  err => {
    const msg = err.response?.data?.detail || err.message || "Request failed";
    if (err.response?.status === 401 && !err.config?.url?.includes("/portal/login")) {
      sessionStorage.removeItem("iws_token");
      window.location.href = "/portal";
    }
    return Promise.reject(new Error(msg));
  }
);

// Expose all methods explicitly (DELETE/PATCH/PUT needed by Admin page)
const api = {
  get:    (url, cfg)        => client.get(url, cfg),
  post:   (url, data, cfg)  => client.post(url, data, cfg),
  patch:  (url, data, cfg)  => client.patch(url, data, cfg),
  put:    (url, data, cfg)  => client.put(url, data, cfg),
  delete: (url, cfg)        => client.delete(url, cfg),
};

export default api;
